import React, { useEffect } from 'react';
import PageContainer from '../../components/PageContainer';
import MainContent from '../../components/MainContent';
import PageTitle from '../../components/Common/PageTitle/PageTitle';
import ActionDropdownItem from '../../components/Common/PageTitle/ActionDropdownItem';
import { useSchool } from '../../DataStore/SchoolContext';
import { useTheme } from '../../DataStore/ThemeContext';
import Pagination from '../../components/Common/Pagination';
import ActivityLoader from '../../components/Common/ActivityLoader';
import Notification from '../../components/Common/Notification';
import functions from '../../util/functions';
import { useFeesDiscount } from '../../DataStore/FeesDiscountContext';
import DiscountListHead from '../../components/SchoolFees/DiscountListHead';

const ManageDiscountPage = () => {

    const {notify, getClasses} = useSchool();
    const {currentNotify} = useTheme();
    const {getFeesDiscountListing, feesDiscountListing, metaData, setCurrentPage, searchText} = useFeesDiscount();
    

    useEffect(()=>{
        getClasses();
        if(!feesDiscountListing){
            getFeesDiscountListing();
        }
    }, [])

   
    // Filtered students based on searchText
    const filteredTransactions = Array.isArray(feesDiscountListing)
        ? feesDiscountListing.filter(
              (transaction) =>
                  transaction.student.full_name?.toLowerCase().includes(searchText.toLowerCase()) ||
                  transaction.student.reg_no?.toLowerCase().includes(searchText.toLowerCase()) ||
                  transaction.balance?.toLowerCase().includes(searchText.toLowerCase())

          )
        : [];


   

    const PageActions = ()=>(<>
        <ActionDropdownItem iconClass="fa fa-refresh text-success" label="Refresh" onClick={()=>getFeesDiscountListing(true)}/>
        </>)


    return (
        <>
        <PageContainer>
            <MainContent>
                <PageTitle
                    title="Manage Discounts"
                    description="View and manage recurring school fees discounts."
                    iconClass="fa fa-handshake"
                    PageActions={PageActions}
                    sticky={true}
                    Pagination={metaData ? <Pagination
                        metaData={metaData}
                        onPageChange={(page) => setCurrentPage(page)}
                        loadMore={false}
                /> : <></>}
                />
                {notify}
                {currentNotify}
                
                <div className="card">
                    <DiscountListHead />
                    <div className="card-body">
                        <table className="table table-hover">
                            <thead className="table-light">
                                <tr>
                                    <th>Student Name</th>
                                    <th>Gender</th>
                                    <th>Reg No.</th>
                                    <th>Class</th>
                                    <th>Residence</th>
                                    <th>Vote</th>
                                    <th>Amount</th>
                                    <th>Created By</th>
                                    <th>Date Created</th>
                                </tr>
                            </thead>
                            <tbody>
                             {Array.isArray(filteredTransactions) && filteredTransactions.map((item)=>
                                <tr key={item.student.id}>
                                    <td>{item.student.full_name}</td>
                                    <td>{item.student.gender}</td>
                                    <td>{item.student.reg_no}</td>
                                    <td>{item.student.class?.class_name || ''}</td>
                                    <td>{item.student.residence?.residence_name || ''}</td>

                                    <td>{item.vote?.vote_name || ''}</td>
                                    <td>{functions.numberFormat(item.amount)}</td>
                                    <td>{item.created_by?.username || ''}</td>
                                    <td>{functions.formatDate(item.discount_date)}</td>
                                </tr>
                            )}

                            </tbody>
                        </table>

                    {!getFeesDiscountListing && <ActivityLoader />}
                        {filteredTransactions.length === 0 && (
                            <Notification message="No recurring discount record found." closable={false} />
                        )}
                    
                    </div>
                </div>               


               
                
            </MainContent>
        </PageContainer>
       
        </>
    );
};

export default ManageDiscountPage;
